// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lZ","tile":"l0","imageWrapper":"l1","img":"l2","header":"l3","caption":"l4"};